import React, {forwardRef, useState} from 'react';
import {ProjectStyle, TextStyle} from '../assets/css/Styles';
import {Container, Row, Col} from 'react-bootstrap';
import EachProject from './EachProject';
import ProjectModal from './ProjectModal';

// feature image links
// eslint-disable-next-line max-len
import CotrackMiniImage1 from '../assets/images/featureGraphics/Cotrack-mini/cotract_mini_feature_graphic.png';
// eslint-disable-next-line max-len
import CtnewsImage1 from '../assets/images/featureGraphics/Ctnews/ctnews-feature-graphic.png';
// eslint-disable-next-line max-len
import CtnewsImage2 from '../assets/images/featureGraphics/Ctnews/ctnews_phone_1.png';
// eslint-disable-next-line max-len
import CtnewsImage3 from '../assets/images/featureGraphics/Ctnews/ctnews_tablet_1.png';
// eslint-disable-next-line max-len
import SmardroponicsImage1 from '../assets/images/featureGraphics/Smardroponics/authentication.png';
// eslint-disable-next-line max-len
import SmardroponicsImage2 from '../assets/images/featureGraphics/Smardroponics/smardroponics_feature_image.png';
// eslint-disable-next-line max-len
import SmardroponicsImage3 from '../assets/images/featureGraphics/Smardroponics/smardroponics_tablet_signin.png';
// eslint-disable-next-line max-len
import ExpoTodoImage1 from '../assets/images/featureGraphics/ExpoTodo/expo-todo.png';
// eslint-disable-next-line max-len
import ExpoTodoImage2 from '../assets/images/featureGraphics/ExpoTodo/Screenshot_1.png';
// eslint-disable-next-line max-len
import ExpoTodoImage3 from '../assets/images/featureGraphics/ExpoTodo/Screenshot_2.png';
// eslint-disable-next-line max-len
import ExpoTodoImage4 from '../assets/images/featureGraphics/ExpoTodo/Screenshot_3.png';

// logo links
import electronImage from '../assets/images/techLogos/electron.png';
import reactImage from '../assets/images/techLogos/reactlogo2.png';
import nedbImage from '../assets/images/techLogos/nedb.png';
import firebaseImage from '../assets/images/techLogos/firebase.png';
import newsapiImage from '../assets/images/techLogos/newsapi.png';
import arduinoImage from '../assets/images/techLogos/arduino.png';
import cssImage from '../assets/images/techLogos/csslogo.png';
import admobImage from '../assets/images/techLogos/google_admob.png';
import reactNavigationImage from
  '../assets/images/techLogos/react_navigation.png';
import expoImage from '../assets/images/techLogos/expo.png';
import typescriptImage from '../assets/images/techLogos/typescript.png';
import jestImage from '../assets/images/techLogos/jest.png';
import sqliteImage from '../assets/images/techLogos/sqlite.png';

export const Projects = forwardRef(({...props}, ref) => {
  const [showProjectModal, setShowProjectModal] = useState(false);
  const [name, setName] = useState('');
  const [motto, setMotto] = useState('');
  const [description, setDescription] = useState('');
  const [images, setImages] = useState([]);
  const [buttonInfo, setButtonInfo] = useState([]);
  return (
    <Container ref={ref} style={ProjectStyle.container}>
      <ProjectModal
        show={showProjectModal}
        closeModal={() => setShowProjectModal(false)}
        projectName={name}
        projectMotto={motto}
        projectDescription={description}
        projectImages={images}
        projectButtons={buttonInfo}
      />
      <Col>
        <Col style={TextStyle.mainTitleDiv}>
          <span id='main-title' style={TextStyle.mainTitleTxt}>
            Projects
          </span>
          <span style={TextStyle.mainTitleTxtBorderBottom} />
        </Col>
        <Col style={ProjectStyle.specificProjects}>
          <Row /* noGutters={true}*/ style={ProjectStyle.specificProjectsRow}>
            <Col style={ProjectStyle.specificProjectCol}>
              <EachProject
                name='Cotrack-mini'
                imgSrc={CotrackMiniImage1}
                tools={
                  [
                    {name: 'Electron', icon: electronImage},
                    {name: 'React', icon: reactImage},
                    {name: 'CSS', icon: cssImage},
                    {name: 'NeDB', icon: nedbImage},
                  ]
                }
                openProjectModal={() => setShowProjectModal(true)}
                setName={() => setName('Cotrack-mini')}
                setMotto={() => setMotto('Attendance monitor')}
                setDescription={() => setDescription('Cotrack-mini is an ' +
                'attendance monitoring desktop application. ' +
                'It is available for Windows OS, Linux OS and Mac OS ')}
                setImages={() => setImages([
                  {name: 'Cotrack mini image 1', source: CotrackMiniImage1},
                ])}
                setButtonInfo={() => setButtonInfo([
                  {name: 'Windows', link: 'https://www.googleapis.com/drive/v3/files/1EgZuKyzI7YqLRmcc_N_isKqf-55uT74t?alt=media&key=AIzaSyDJ2UKBsAGZ6xx16E-5e6QO23lbdvBgjEA'},
                  {name: 'Linux', link: 'https://www.googleapis.com/drive/v3/files/11dSL0i-vYODC74KBQ8IWpigs8Um2r6qm?alt=media&key=AIzaSyDJ2UKBsAGZ6xx16E-5e6QO23lbdvBgjEA'},
                  {name: 'Mac', link: '#'},
                ])}
              />
            </Col>
            <Col style={ProjectStyle.specificProjectCol}>
              <EachProject
                name='CTnews'
                imgSrc={CtnewsImage1}
                tools={
                  [
                    {name: 'React Native', icon: reactImage},
                    {name: 'Firebase', icon: firebaseImage},
                    {name: 'News API', icon: newsapiImage},
                    {name: 'Google admob', icon: admobImage},
                  ]
                }
                openProjectModal={() => setShowProjectModal(true)}
                setName={() => setName('CTnews')}
                setMotto={() => setMotto('All in one news application')}
                setDescription={() => setDescription('CTnews is an ' +
              'all-in-one news application. It is available for ' +
              'both Android and IOS')}
                setImages={() => setImages([
                  {name: 'CTnews image 1', source: CtnewsImage1},
                  {name: 'CTnews image 2', source: CtnewsImage2},
                  {name: 'CTnews image 3', source: CtnewsImage3},
                ])}
                setButtonInfo={() => setButtonInfo([
                  {name: 'Android', link: 'https://play.google.com/store/apps/details?id=com.clemotec.ctnews'},
                  {name: 'IOS', link: '#'},
                ])}
              />
            </Col>
            <Col style={ProjectStyle.specificProjectCol}>
              <EachProject
                name='Smardroponics'
                imgSrc={SmardroponicsImage1}
                tools={
                  [
                    {name: 'React Native', icon: reactImage},
                    {name: 'Arduino', icon: arduinoImage},
                    {name: 'Firebase', icon: firebaseImage},
                    {name: 'React navigation', icon: reactNavigationImage},
                  ]
                }
                openProjectModal={() => setShowProjectModal(true)}
                setName={() => setName('Smardroponics')}
                setMotto={() => setMotto('A smart hydroponic sytem')}
                setDescription={() => setDescription('Smardroponics is a ' +
                'mobile application for a project called ' +
                '\'Smart Hydroponic System\'.' +
                'It is available for both Android and IOS')}
                setImages={() => setImages([
                  {name: 'Smardroponics image 1', source: SmardroponicsImage1},
                  {name: 'Smardroponics image 2', source: SmardroponicsImage2},
                  {name: 'Smardroponics image 3', source: SmardroponicsImage3},
                ])}
                setButtonInfo={() => setButtonInfo([
                  {name: 'Android', link: 'https://play.google.com/store/apps/details?id=com.smardroponics'},
                  {name: 'IOS', link: '#'},
                ])}
              />
            </Col>
            <Col style={ProjectStyle.specificProjectCol}>
              <EachProject
                name='Expo Todo'
                imgSrc={ExpoTodoImage1}
                tools={
                  [
                    {name: 'Expo + Redux', icon: expoImage},
                    {name: 'TypeScript', icon: typescriptImage},
                    {name: 'Jest + Enzyme + Detox', icon: jestImage},
                    {name: 'SQLite', icon: sqliteImage},
                  ]
                }
                openProjectModal={() => setShowProjectModal(true)}
                setName={() => setName('Expo Todo')}
                setMotto={() => setMotto('Track all your activities')}
                setDescription={() => setDescription('Expo Todo is a ' +
                'mobile application for tracking todo activities. ' +
                'It is available for both Android and IOS')}
                setImages={() => setImages([
                  {name: 'Expo Todo image 1', source: ExpoTodoImage1},
                  {name: 'Expo Todo image 2', source: ExpoTodoImage2},
                  {name: 'Expo Todo image 3', source: ExpoTodoImage3},
                  {name: 'Expo Todo image 4', source: ExpoTodoImage4},
                ])}
                setButtonInfo={() => setButtonInfo([
                  {name: 'Android', link: 'https://play.google.com/store/apps/details?id=com.clemotec.expotodo'},
                  {name: 'IOS', link: '#'},
                ])}
              />
            </Col>
          </Row>
        </Col>
      </Col>
    </Container>
  );
});
